import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs'
import { cmsApi, oneAssetApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  private announceFavNumSource = new Subject<string>()
  favNumAnnounce$ = this.announceFavNumSource.asObservable();

  constructor(private http: HttpClient) { }

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];


  announceFavNum(favNum: string) {
    this.announceFavNumSource.next(favNum)
  }

  changeFormatDate(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate()
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return day + ' ' + monthTh['name'] + ' ' + year;
  }

  getBanner() {
    const URL = cmsApi + '/get_banner_active';
    const body = {};
    return this.http.post(URL, body);
  }

  getBannerPrivate() {
    const URL = cmsApi + '/get_banner_private_fund';
    const body = {};
    return this.http.post(URL, body);
  }

  getBannerProvident() {
    const URL = cmsApi + '/get_banner_provident';
    const body = {};
    return this.http.post(URL, body);
  }


  get_FavNum(IP) {
    const URL = cmsApi + '/get_FavNum';
    const body = { IP: IP };
    return this.http.post(URL, body);
  }

  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }



  getAnnounce() {
    const URL = cmsApi + '/get_announceList_top3';
    const body = {};
    return this.http.post(URL, body);
  }

  getFundRecomm() {
    const URL = cmsApi + '/get_fundRecomList_top3';
    const body = {};
    return this.http.post(URL, body);
  }


  getEartUpdate() {
    const URL = cmsApi + '/get_earthupdateList_top2';
    const body = {};
    return this.http.post(URL, body);
  }

  getPromotion() {
    const URL = cmsApi + '/get_promotionList_top1';
    const body = {};

    return this.http.post(URL, body);
  }


  getAnnounceByID(announce_id) {
    const URL = cmsApi + '/get_announceById';
    const body = { announce_id: announce_id };

    return this.http.post(URL, body);
  }

  getmarketByID(market_id) {
    const URL = cmsApi + '/get_marketById';
    const body = { market_id: market_id };

    return this.http.post(URL, body);
  }

  getEartUpdateByID(earthupdateid) {
    const URL = cmsApi + '/get_earthupdateById';
    const body = { earthupdateid: earthupdateid };

    return this.http.post(URL, body);
  }

  getpromotionByID(promotionid) {
    const URL = cmsApi + '/get_promotionById';
    const body = { promotionid: promotionid };

    return this.http.post(URL, body);
  }

  getbenefitByID(benefitid) {
    const URL = cmsApi + '/get_benefitById';
    const body = { benefitid: benefitid };

    return this.http.post(URL, body);
  }

  get_IsFav(IP, fundid, currency) {
    const URL = cmsApi + '/get_IsFav';
    const body = {
      IP: IP,
      fundid: fundid,
      currency: currency
    };
    return this.http.post(URL, body);
  }

  add_IsFav(IP, fundid, currency) {
    const URL = cmsApi + '/add_IsFav';
    const body = {
      IP: IP,
      fundid: fundid,
      currency: currency
    };
    return this.http.post(URL, body);
  }

  delIsFav(IP, fundid, currency) {
    const URL = cmsApi + '/delIsFav';
    const body = {
      IP: IP,
      fundid: fundid,
      currency: currency
    };
    return this.http.post(URL, body);
  }

  getFundHoliday(dateFrom, dateTo) {
    const URL = oneAssetApi + '/Fund/GetFundHoliday';
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo
    };
    return this.http.post(URL, body);
  }

  checkCustomerPID(pid, type, source) {
    const URL = oneAssetApi + '/Account/CheckCustomerPID';
    const body = {
      pid: pid,
      type: type,
      source: source
    };
    return this.http.post(URL, body);
  }

  checkCustomerOTP(pid, type, source, refOTP, otp) {
    const URL = oneAssetApi + '/Account/CheckCustomerOTP';
    const body = {
      pid: pid,
      type: type,
      source: source,
      refOTP: refOTP,
      otp: otp
    };
    return this.http.post(URL, body);
  }

  loadConsent(uid, pidNo) {
    let path = '/pdpa/GetConsentInfoByAccountAsync/?id=' + pidNo;
    if (uid !== '' && uid !== undefined) {
      path = '/pdpa/GetConsentInfoByUserIdAsync/?id=' + uid;
    }
    const URL = oneAssetApi + path;
    return this.http.get(URL);
  }

  sendConsent(pid, purposes) {
    const URL = oneAssetApi + '/pdpa/SetConsentInfoByAccountAsync';
    const body = {
      identifier: pid,
      purposes: purposes,
    };
    return this.http.post(URL, body);
  }

  getPrivacyPolicy() {
    const URL = oneAssetApi + '/Info/PrivacyPolicy';
    return this.http.get(URL);
  }


  GetDataRequest(pid) {
    const URL = oneAssetApi + '/report/GetDataRequest';
    const body = {
      PIDNo: pid,
    };
    return this.http.post(URL, body);
  }

  downloadFilePdf(temcod, horder, date, fundlist) {
    const URL = oneAssetApi + '/report/DownloadFilePdf';
    const body = {
      TemplateCode: temcod,
      HolderNo: horder,
      Date: date,
      FundList: fundlist,
    };
    return this.http.post(URL, body);
  }

  sendTaxConsent(pidNo, isAcceptConsent, year, agentId, language) {
    const URL = oneAssetApi + '/consent/tax';
    const body = {
      pidNo: pidNo,
      agentId: agentId,
      given: isAcceptConsent,
      consentId: '',
      source: 'Web Site',
      type: 'tax',
      year: year,
      language: language,
    };
    return this.http.post(URL, body);
  }

  getTaxConsent(pidNo, agentId) {
    const URL = oneAssetApi + '/consent/GetTaxConsent';
    const body = {
      pidNo: pidNo,
      agentId: agentId,
      type: 'tax',
    };
    return this.http.post(URL, body);
  }

  checkUID(uid) {
    const URL = oneAssetApi + '/info/CheckUID';
    const body = {
      uid: uid,
    };
    return this.http.post(URL, body);
  }

  sendOneamToPine(uid) {
    const URL = oneAssetApi + '/info/OneamToPine';
    const body = {
      uid: uid,
    };
    return this.http.post(URL, body);
  }

  GetIndexLevelList() {
    const URL = oneAssetApi + '/IndexLevel/GetIndexLevel';
    return this.http.get(URL);
  }
}
